import {getCurrentUserId, getUsers} from 'mattermost-redux/selectors/entities/common';
import {batchAsyncDebounce} from 'mattermost-redux/utils/debounce';
import type {AppDispatch} from 'stores/redux_store';

import {getUsersByIds} from '../api/get_users_by_ids';
import type {User} from '../types/user';

import {type GetStateFunc} from 'mattermost-redux/types/actions';

import {receivedUsers} from './received_users';

type Payload = {userIds: Array<User['id']>; since?: number};

export const fetchUsersByIds = (payload: Payload) => async (dispatch: AppDispatch, getState: GetStateFunc) => {
    const {userIds, since} = payload;

    if (!userIds.length) {
        return;
    }

    const state = getState();
    const currentUserId = getCurrentUserId(state);

    const userIdsSet = new Set(userIds);
    userIdsSet.delete(currentUserId);

    if (!userIdsSet.size) {
        return;
    }

    const uniqUsers = Array.from(userIdsSet);

    const allUsers = getUsers(state);

    const userIdsToRequest = uniqUsers.filter((userId) => !allUsers[userId]?.username);

    if (!userIdsToRequest.length) {
        return;
    }

    const data = await getUsersByIds({
        userIds: userIdsToRequest,
        since,
    }, dispatch);

    if (data.users.length) {
        dispatch(receivedUsers(data.users));
    }

    return data;
};

const fetchUsersByUserIdsList = (userIdsList: string[]) => (dispatch: AppDispatch) =>
    dispatch(
        fetchUsersByIds({
            userIds: userIdsList,
        }),
    );

export const fetchUsersByIdsDebounced = batchAsyncDebounce(fetchUsersByUserIdsList);
